import { authCookieHook } from "./hooks/(beforeRequest)/authCookie";
import { base } from "./base";
import { errorToastHook } from "./hooks/(beforeError)/errorToast";
import { loaderEndHook } from "./hooks/(afterResponse)/loaderEnd";
import { loaderErrorHook } from "./hooks/(beforeError)/loaderError";
import { loaderStartHook } from "./hooks/(beforeRequest)/loaderStart";
import { refreshAuthTokenHook } from "./hooks/(afterResponse)/refreshAuthToken";

// separate http instance for cookie based authentication rollout
// credentials mode is decided per-request by authCookieHook (based on opt-in
// state), not set instance-wide here — see that hook for why.
export const httpAuthCookie = base.extend({
  hooks: {
    afterResponse: [loaderEndHook, refreshAuthTokenHook],
    beforeError: [loaderErrorHook, errorToastHook],
    beforeRequest: [loaderStartHook, authCookieHook],
  },
});
